
const digest = '42fec1b74a355115aa303cd99612b3d52dd7194ae4e2d30d43f2be4e44c7ad35';
const classes = {"invalidPatientText":"_invalidPatientText_mg2rl_1"};
const css = `._invalidPatientText_mg2rl_1 {
  font-weight: 500;
  font-size: 14px;
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  